module.exports = __webpack_public_path__ + "img/d05b9dd.png";